import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { PropertySet, PropertySetValue } from '../bom'
import {
  ComparatorBuilder,
  ElderFormFieldLabelDirective,
  ElderQuantityInputControlComponent,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { FormsModule } from '@angular/forms'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { AsyncPipe } from '@angular/common'

class PPVal {
  constructor(
    public readonly key: string,
    public readonly value: PropertySetValue
  ) {}
}

@Component({
  selector: 'app-bom-property-set-detail',
  templateUrl: './bom-property-set-detail.component.html',
  styleUrls: ['./bom-property-set-detail.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    ElderQuantityInputControlComponent,
    ElderFormFieldLabelDirective,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class BomPropertySetDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly propertySet$ = new BehaviorSubject<PropertySet>(null)

  public readonly propertySetValues$ = new BehaviorSubject<PPVal[]>([])

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set propertySet(propertySet: PropertySet) {
    if (propertySet) {
      const properties = propertySet.properties
      this.propertySetValues$.next(
        Object.keys(properties)
          .map((k) => new PPVal(k, properties[k]))
          .sort(ComparatorBuilder.fieldSort('key'))
      )
    }
  }
}
